import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import ArcGaugeProps from './ArcGaugeProps'
import KendoArcGaugeColor from './KendoArcGaugeColor'

import GaugeArea from '../Common/GaugeArea'
import Scale from './Scale'

export default {
    props: ArcGaugeProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        GaugeArea, 
        Scale
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoArcGauge(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoArcGauge()
        },
        _resolveChildren() {
            this.resolveChildren('colors', KendoArcGaugeColor.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/KendoArcGauge/KendoArcGaugeMixin.js